var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("oilAllowance.BoxWrap.manage") } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "FPermission",
                  rawName: "v-FPermission",
                  value: { pageName: _vm.pageName, list: ["LIST"] },
                  expression: "{pageName, list: ['LIST']}",
                },
              ],
              staticClass: "action-container",
            },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.searchVal,
                    size: "small",
                    inline: "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("oilAllowance.form.empNo") } },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.empNo },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "empNo", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("oilAllowance.form.empName") } },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.empName },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "empName", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("oilAllowance.form.status") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.searchVal.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchVal, "status", $$v)
                            },
                            expression: "searchVal.status",
                          },
                        },
                        _vm._l(
                          _vm.optConfig.dailySignRecordStatusOptions,
                          function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.name, value: item.code },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "flexRow",
                      attrs: { label: _vm.$t("oilAllowance.form.date") },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "startDay" } },
                        [
                          _c("FormDatePicker", {
                            attrs: {
                              val: _vm.searchVal.startDay,
                              valueformat: "yyyyMMdd",
                              "picker-options": _vm.startPickerOptions,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchVal,
                                  "startDay",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "picker-line" }, [_vm._v("-")]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "endDay" } },
                        [
                          _c("FormDatePicker", {
                            attrs: {
                              val: _vm.searchVal.endDay,
                              valueformat: "yyyyMMdd",
                              "picker-options": _vm.endPickerOptions,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(_vm.searchVal, "endDay", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.teamType == "GLOBAL"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("mealAllowance.form.teamType"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t(
                                  "mealAllowance.form.optionPlaceholder"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchVal.teamType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "teamType", $$v)
                                },
                                expression: "searchVal.teamType",
                              },
                            },
                            _vm._l(
                              _vm.lookupList["TEAM_TYPE"],
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer-right" }, slot: "footer-right" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.resetData },
                },
                [_vm._v(_vm._s(_vm.$t("common.reset")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  staticClass: "t-search-btn",
                  attrs: { size: "small", icon: "el-icon-search" },
                  on: { click: _vm.searchData },
                },
                [_vm._v(_vm._s(_vm.$t("common.search")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("oilAllowance.BoxWrap.list") },
        },
        [
          _c(
            "div",
            { attrs: { slot: "header-right" }, slot: "header-right" },
            [
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT2"] },
                        expression: "{pageName, list: ['EXPORT2']}",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        _vm.downloadExcel2(
                          _vm.$t("oilAllowance.common.exportCarSubsidyText")
                        )
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.exportCarSubsidy")))]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT"] },
                        expression: "{pageName, list: ['EXPORT']}",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        _vm.downloadExcel(
                          _vm.$t("oilAllowance.common.exportText")
                        )
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.export")))]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: {
                          pageName: _vm.pageName,
                          list: ["EXPORT_DETAIL"],
                        },
                        expression: "{pageName, list: ['EXPORT_DETAIL']}",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        _vm.downloadExcelDetail(
                          _vm.$t("oilAllowance.common.exportDetailText")
                        )
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.exportDetail")))]
                ),
              ],
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.table.listLoading,
                  expression: "table.listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.table.list,
                stripe: "",
                border: "",
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "signRecordNo",
                  label: _vm.$t("oilAllowance.table.signRecordNo"),
                  width: "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "dateCycle",
                  label: _vm.$t("oilAllowance.table.dateCycle"),
                  width: "250",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "dayFormatted",
                  label: _vm.$t("oilAllowance.table.dayFormatted"),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empNo",
                  label: _vm.$t("oilAllowance.table.empNo"),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empName",
                  label: _vm.$t("oilAllowance.table.empName"),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "estimateDistance",
                  label: _vm.$t("oilAllowance.table.estimateDistance"),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "estimateAllowance",
                  label: _vm.$t("oilAllowance.table.estimateAllowance"),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: _vm.$t("oilAllowance.table.status"),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.formatEnum(
                                scope.row.status,
                                "dailySignRecordStatusOptions"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("oilAllowance.table.action"),
                  fixed: "right",
                  width: "400",
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "t-search-btn",
                            on: {
                              click: function ($event) {
                                return _vm.viewRoute(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看路线")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "t-search-btn",
                            on: {
                              click: function ($event) {
                                return _vm.viewDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看明细")]
                        ),
                        _vm._v(" "),
                        scope.row.submitButtonFlag && scope.row.status !== 30
                          ? _c(
                              "el-button",
                              {
                                staticClass: "t-search-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.signSubmitClick(scope.row)
                                  },
                                },
                              },
                              [_vm._v("提交审批")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.approveButtonFlag && scope.row.status === 30
                          ? _c(
                              "el-button",
                              {
                                staticClass: "t-search-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.auditClick(scope.row)
                                  },
                                },
                              },
                              [_vm._v("审批")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status !== 10
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "FPermission",
                                    rawName: "v-FPermission",
                                    value: {
                                      pageName: _vm.pageName,
                                      list: ["L_HISTORY"],
                                    },
                                    expression:
                                      "{pageName, list: ['L_HISTORY']}",
                                  },
                                ],
                                staticClass: "t-search-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.viewApproveHistory(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看审批历史")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.table.total > 0,
                expression: "table.total>0",
              },
            ],
            attrs: {
              total: _vm.table.total,
              page: _vm.table.currPage,
              limit: _vm.table.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.table, "currPage", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.table, "limit", $event)
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            width: "1300px",
            "drag-flag": false,
            "is-show": _vm.isShowModelView,
            "custom-title": "查看明细",
            "is-hide-footer": true,
            "save-item": _vm.closeView,
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowModelView = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowModelView = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "main-table-container" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.table2.listLoading,
                      expression: "table2.listLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.table2.list,
                    stripe: "",
                    "highlight-current-row": "",
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "planTaskDateFormatted",
                      label: _vm.$t("oilAllowance.table2.planTaskDate"),
                      "min-width": "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "empNo",
                      label: _vm.$t("oilAllowance.table2.empNo"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "empName",
                      label: _vm.$t("oilAllowance.table2.empName"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "planTaskTime",
                      label: _vm.$t("oilAllowance.table2.planTaskTime"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "actualPlanTaskTime",
                      label: _vm.$t("oilAllowance.table2.actualPlanTaskTime"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "planTaskType",
                      label: _vm.$t("oilAllowance.table2.planTaskType"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.planTaskType,
                                    "planTaskTypeOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "actualPlanTaskFlag",
                      label: _vm.$t("oilAllowance.table2.category"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.actualPlanTaskFlag,
                                    "PTFlagOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rtlSapId",
                      label: _vm.$t("oilAllowance.table2.rtlSapId"),
                      "min-width": "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rtlFullName",
                      label: _vm.$t("oilAllowance.table2.rtlFullName"),
                      "min-width": "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "checkInDateTime",
                      label: _vm.$t("oilAllowance.table2.checkInDateTime"),
                      "min-width": "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "checkInAddress",
                      label: _vm.$t("oilAllowance.table2.checkInAddress"),
                      "min-width": "250",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "driveType",
                      label: _vm.$t("oilAllowance.table2.driveType"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.driveType,
                                    "driveTypeOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "driveRemark",
                      label: _vm.$t("oilAllowance.table2.driveRemark"),
                      "min-width": "250",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "signType",
                      label: _vm.$t("oilAllowance.table2.signType"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.signType,
                                    "signTypeOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.table2.total > 0,
                    expression: "table2.total>0",
                  },
                ],
                attrs: {
                  total: _vm.table2.total,
                  page: _vm.table2.currPage,
                  limit: _vm.table2.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.table2, "currPage", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.table2, "limit", $event)
                  },
                  pagination: _vm.fetchSignList,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            width: "1300px",
            "drag-flag": false,
            "is-show": _vm.isShowModelApproveHistoryView,
            "custom-title": "查看审批历史",
            "is-hide-footer": true,
            "save-item": _vm.closeApproveHistoryView,
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowModelApproveHistoryView = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowModelApproveHistoryView = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "main-table-container" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.table6.listLoading,
                      expression: "table6.listLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.table6.list,
                    stripe: "",
                    "highlight-current-row": "",
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "planTaskDateFormatted",
                      label: _vm.$t("oilAllowance.table2.planTaskDate"),
                      "min-width": "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "empNo",
                      label: _vm.$t("oilAllowance.table2.empNo"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "empName",
                      label: _vm.$t("oilAllowance.table2.empName"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "planTaskTime",
                      label: _vm.$t("oilAllowance.table2.planTaskTime"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "actualPlanTaskTime",
                      label: _vm.$t("oilAllowance.table2.actualPlanTaskTime"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "planTaskType",
                      label: _vm.$t("oilAllowance.table2.planTaskType"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.planTaskType,
                                    "planTaskTypeOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "actualPlanTaskFlag",
                      label: _vm.$t("oilAllowance.table2.category"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.actualPlanTaskFlag,
                                    "PTFlagOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rtlSapId",
                      label: _vm.$t("oilAllowance.table2.rtlSapId"),
                      "min-width": "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rtlFullName",
                      label: _vm.$t("oilAllowance.table2.rtlFullName"),
                      "min-width": "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "checkInDateTime",
                      label: _vm.$t("oilAllowance.table2.checkInDateTime"),
                      "min-width": "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "checkInAddress",
                      label: _vm.$t("oilAllowance.table2.checkInAddress"),
                      "min-width": "250",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "driveType",
                      label: _vm.$t("oilAllowance.table2.driveType"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.driveType,
                                    "driveTypeOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "driveRemark",
                      label: _vm.$t("oilAllowance.table2.driveRemark"),
                      "min-width": "250",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "signType",
                      label: _vm.$t("oilAllowance.table2.signType"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.signType,
                                    "signTypeOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "auditRemark",
                      label: _vm.$t("oilAllowance.table2.auditRemark"),
                      "min-width": "250",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("oilAllowance.table.action"),
                      width: "150",
                      align: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.planTaskType === "A03"
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "t-search-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewApproveDetail(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("查看明细")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.table6.total > 0,
                    expression: "table6.total>0",
                  },
                ],
                attrs: {
                  total: _vm.table6.total,
                  page: _vm.table6.currPage,
                  limit: _vm.table6.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.table6, "currPage", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.table6, "limit", $event)
                  },
                  pagination: _vm.fetchApproveDetailSignList,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main-table-container" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.table3.listLoading,
                      expression: "table3.listLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.table3.list,
                    stripe: "",
                    "highlight-current-row": "",
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "auditName",
                      label: _vm.$t("oilAllowance.table3.auditName"),
                      "min-width": "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "auditTime",
                      label: _vm.$t("oilAllowance.table3.auditTime"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "auditStatus",
                      label: _vm.$t("oilAllowance.table3.auditStatus"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.auditStatus,
                                    "auditStatusOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "refuseReason",
                      label: _vm.$t("oilAllowance.table3.refuseReason"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.table3.total > 0,
                    expression: "table3.total>0",
                  },
                ],
                attrs: {
                  total: _vm.table3.total,
                  page: _vm.table3.currPage,
                  limit: _vm.table3.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.table3, "currPage", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.table3, "limit", $event)
                  },
                  pagination: _vm.fetchApproveHistoryList,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            width: "1000px",
            "drag-flag": false,
            "is-show": _vm.isShowModelAuditView,
            "custom-title": "审批",
            "save-item": _vm.saveAuditView,
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowModelAuditView = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowModelAuditView = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "main-table-container" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.table4.listLoading,
                      expression: "table4.listLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.table4.list,
                    stripe: "",
                    "highlight-current-row": "",
                    "tooltip-effect": "dark",
                  },
                  on: { "selection-change": _vm.handleCheckedMain },
                },
                [
                  this.form.auditStatus === "30"
                    ? _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          width: "55",
                          align: "center",
                          selectable: _vm.isRowSelectable,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "planTaskDateFormatted",
                      label: _vm.$t("oilAllowance.table2.planTaskDate"),
                      "min-width": "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "empNo",
                      label: _vm.$t("oilAllowance.table2.empNo"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "empName",
                      label: _vm.$t("oilAllowance.table2.empName"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "planTaskTime",
                      label: _vm.$t("oilAllowance.table2.planTaskTime"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "actualPlanTaskTime",
                      label: _vm.$t("oilAllowance.table2.actualPlanTaskTime"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "planTaskType",
                      label: _vm.$t("oilAllowance.table2.planTaskType"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.planTaskType,
                                    "planTaskTypeOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "actualPlanTaskFlag",
                      label: _vm.$t("oilAllowance.table2.category"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.actualPlanTaskFlag,
                                    "PTFlagOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rtlSapId",
                      label: _vm.$t("oilAllowance.table2.rtlSapId"),
                      "min-width": "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rtlFullName",
                      label: _vm.$t("oilAllowance.table2.rtlFullName"),
                      "min-width": "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "checkInDateTime",
                      label: _vm.$t("oilAllowance.table2.checkInDateTime"),
                      "min-width": "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "checkInAddress",
                      label: _vm.$t("oilAllowance.table2.checkInAddress"),
                      "min-width": "250",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "driveType",
                      label: _vm.$t("oilAllowance.table2.driveType"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.driveType,
                                    "driveTypeOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "driveRemark",
                      label: _vm.$t("oilAllowance.table2.driveRemark"),
                      "min-width": "250",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "signType",
                      label: _vm.$t("oilAllowance.table2.signType"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.signType,
                                    "signTypeOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "auditRemark",
                      label: _vm.$t("oilAllowance.table2.auditRemark"),
                      "min-width": "250",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("oilAllowance.table.action"),
                      width: "150",
                      align: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.planTaskType === "A03"
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "t-search-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewApproveDetail(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("查看明细")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.table4.total > 0,
                    expression: "table4.total>0",
                  },
                ],
                attrs: {
                  total: _vm.table4.total,
                  page: _vm.table4.currPage,
                  limit: _vm.table4.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.table4, "currPage", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.table4, "limit", $event)
                  },
                  pagination: _vm.fetchApproveSignList,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main-container" },
            [
              _c(
                "el-form",
                { attrs: { model: _vm.form, "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "审批状态",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择审批状态" },
                          model: {
                            value: _vm.form.auditStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "auditStatus", $$v)
                            },
                            expression: "form.auditStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "通过", value: "20" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "拒绝", value: "30" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "原因",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          autocomplete: "off",
                        },
                        model: {
                          value: _vm.form.refuseReason,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "refuseReason", $$v)
                          },
                          expression: "form.refuseReason",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            width: "1300px",
            "drag-flag": false,
            "is-show": _vm.isShowDetailModelView,
            "custom-title": "查看明细",
            "is-hide-footer": true,
            "save-item": _vm.closeApproveDetailView,
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowDetailModelView = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowDetailModelView = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "main-table-container" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.table5.listLoading,
                      expression: "table5.listLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.table5.list,
                    stripe: "",
                    "highlight-current-row": "",
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "planTaskDateFormatted",
                      label: _vm.$t("oilAllowance.table2.planTaskDate"),
                      "min-width": "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "empNo",
                      label: _vm.$t("oilAllowance.table2.empNo"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "empName",
                      label: _vm.$t("oilAllowance.table2.empName"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "planTaskTime",
                      label: _vm.$t("oilAllowance.table2.planTaskTime"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "actualPlanTaskTime",
                      label: _vm.$t("oilAllowance.table2.actualPlanTaskTime"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "planTaskType",
                      label: _vm.$t("oilAllowance.table2.planTaskType"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.planTaskType,
                                    "planTaskTypeOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "actualPlanTaskFlag",
                      label: _vm.$t("oilAllowance.table2.category"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.actualPlanTaskFlag,
                                    "PTFlagOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rtlSapId",
                      label: _vm.$t("oilAllowance.table2.rtlSapId"),
                      "min-width": "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rtlFullName",
                      label: _vm.$t("oilAllowance.table2.rtlFullName"),
                      "min-width": "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "checkInDateTime",
                      label: _vm.$t("oilAllowance.table2.checkInDateTime"),
                      "min-width": "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "checkInAddress",
                      label: _vm.$t("oilAllowance.table2.checkInAddress"),
                      "min-width": "250",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "driveType",
                      label: _vm.$t("oilAllowance.table2.driveType"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.driveType,
                                    "driveTypeOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "driveRemark",
                      label: _vm.$t("oilAllowance.table2.driveRemark"),
                      "min-width": "250",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "signType",
                      label: _vm.$t("oilAllowance.table2.signType"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.signType,
                                    "signTypeOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.table5.total > 0,
                    expression: "table5.total>0",
                  },
                ],
                attrs: {
                  total: _vm.table5.total,
                  page: _vm.table5.currPage,
                  limit: _vm.table5.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.table5, "currPage", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.table5, "limit", $event)
                  },
                  pagination: _vm.fetchDetailSignList,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            width: "1300px",
            "drag-flag": false,
            "is-show": _vm.isShowModelApproveDetailView,
            "custom-title": "查看明细",
            "is-hide-footer": true,
            "save-item": _vm.closeApproveDetailView2,
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowModelApproveDetailView = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowModelApproveDetailView = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "main-table-container" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.table6.listLoading,
                      expression: "table6.listLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.table6.list,
                    stripe: "",
                    "highlight-current-row": "",
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "planTaskDateFormatted",
                      label: _vm.$t("oilAllowance.table2.planTaskDate"),
                      "min-width": "150",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "empNo",
                      label: _vm.$t("oilAllowance.table2.empNo"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "empName",
                      label: _vm.$t("oilAllowance.table2.empName"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "planTaskTime",
                      label: _vm.$t("oilAllowance.table2.planTaskTime"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "actualPlanTaskTime",
                      label: _vm.$t("oilAllowance.table2.actualPlanTaskTime"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "planTaskType",
                      label: _vm.$t("oilAllowance.table2.planTaskType"),
                      "min-width": "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.planTaskType,
                                    "planTaskTypeOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "actualPlanTaskFlag",
                      label: _vm.$t("oilAllowance.table2.category"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.actualPlanTaskFlag,
                                    "PTFlagOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rtlSapId",
                      label: _vm.$t("oilAllowance.table2.rtlSapId"),
                      "min-width": "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rtlFullName",
                      label: _vm.$t("oilAllowance.table2.rtlFullName"),
                      "min-width": "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "checkInDateTime",
                      label: _vm.$t("oilAllowance.table2.checkInDateTime"),
                      "min-width": "200",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "checkInAddress",
                      label: _vm.$t("oilAllowance.table2.checkInAddress"),
                      "min-width": "250",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "driveType",
                      label: _vm.$t("oilAllowance.table2.driveType"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.driveType,
                                    "driveTypeOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "driveRemark",
                      label: _vm.$t("oilAllowance.table2.driveRemark"),
                      "min-width": "250",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "signType",
                      label: _vm.$t("oilAllowance.table2.signType"),
                      "min-width": "100",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatEnum(
                                    scope.row.signType,
                                    "signTypeOptions"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "auditRemark",
                      label: _vm.$t("oilAllowance.table2.auditRemark"),
                      "min-width": "250",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.table6.total > 0,
                    expression: "table6.total>0",
                  },
                ],
                attrs: {
                  total: _vm.table6.total,
                  page: _vm.table6.currPage,
                  limit: _vm.table6.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.table6, "currPage", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.table6, "limit", $event)
                  },
                  pagination: _vm.fetchApproveDetailSignList,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("SignMap", {
        ref: "signMap",
        attrs: { "daily-sign-record-pk": _vm.dailySignRecordPk },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }